module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/replay-d011fb27.svg";